export const CONTACT_SALES_URL_HASH = 'contact-sales';
export const LEADS_COLLECTION_URL_HASH = 'leads-collection';

export const rainbowWaveBGStyle =
  'bg-[url("https://images.decodo.com/rainbow_wave_15db536f53_75988a8089/rainbow_wave_15db536f53_75988a8089.svg")]';
export const rainbowWaveSrc =
  'https://images.decodo.com/rainbow_wave_15db536f53_75988a8089/rainbow_wave_15db536f53_75988a8089.svg';

export const apiEndpoints = {
  contactSales: `/api/v1/contact-sales`,
  jobApplication: '/api/v1/career-page',
  ssoLogin: '/api/v1/sso/login',
} as const;
